import { createContext, useContext } from 'react'

export const DashboardPublicContext = createContext<boolean>(false)
export const useDashboardPublicContext = (): boolean =>
  useContext(DashboardPublicContext)
